import {Router} from '@tanstack/react-router';
import {APP_BASE_PATH, getHistory} from './history/history';
import {RouteErrorComponent} from './route-components';
import {parseSearch, stringifySearch} from './search-params/search-params';
import {routeTree} from '../routes/routeTree.gen';

function createAppRouter() {
  const router = new Router({
    routeTree,
    history: getHistory(),
    basepath: APP_BASE_PATH,
    parseSearch,
    stringifySearch,
    trailingSlash: 'preserve',
    defaultErrorComponent: RouteErrorComponent,
    scrollRestoration: () => false,
  });
  window.history.scrollRestoration = 'auto';
  return router;
}

export type AppRouter = ReturnType<typeof createAppRouter>;

let appRouter: AppRouter | null = null;

export function getAppRouter(): AppRouter {
  if (appRouter === null) {
    appRouter = createAppRouter();
  }
  return appRouter;
}

declare module '@tanstack/react-router' {
  interface Register {
    router: AppRouter;
  }
}
